var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAlertFail = function SvgIconAlertFail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.981 74.4258L63.5964 13.5953C57.8168 3.54635 43.2014 3.54635 37.4426 13.5953L2.03727 74.4258C-3.74235 84.4747 3.45099 96.9586 15.1142 96.9586H85.7793C97.4425 96.9586 104.761 84.3509 98.981 74.4258Z",
    fill: "#EC4B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4984 72.2798C53.5753 72.2798 56.1325 74.8178 56.0077 78.0162C56.1532 80.9256 53.4505 83.4637 50.4984 83.4637C47.4214 83.4637 44.8643 80.9256 44.8643 77.8717C44.8643 74.8178 47.4214 72.2798 50.4984 72.2798ZM55.6335 36.0869C56.0285 36.9742 56.1532 37.8615 56.1532 38.8932C56.0285 41.7201 55.7582 44.5264 55.6335 47.3121L54.8643 60.2911C54.7395 61.6943 54.7395 62.9736 54.7395 64.3561C54.6148 66.6466 52.8061 68.4211 50.4984 68.4211C48.1907 68.4211 46.4027 66.7704 46.2572 64.4799C45.883 57.7325 45.488 51.1088 45.1138 44.3613C44.989 42.5868 44.8643 40.7916 44.7188 39.017C44.7188 36.0869 46.3819 33.6727 49.0846 32.9092C51.7873 32.2695 54.4693 33.5489 55.6335 36.0869Z",
    fill: "#FAFAFA"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAlertFail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_alert_fail.ea20c2bf.svg";
export { ForwardRef as ReactComponent };